export default __webpack_public_path__ + "static/media/4.b5dbaf94.png";